export * from './tabs';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/md2/tabs/index.js
// module id = 877
// module chunks = 3